import { render, staticRenderFns } from "./DefaultHome.vue?vue&type=template&id=da979c36&scoped=true&"
import script from "./DefaultHome.vue?vue&type=script&lang=js&"
export * from "./DefaultHome.vue?vue&type=script&lang=js&"
import style0 from "./DefaultHome.vue?vue&type=style&index=0&id=da979c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da979c36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VAvatar,VBtn,VCol,VIcon,VRow})
